(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/results/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/numbergames/results/assets/javascripts/prescript.js');

'use strict';

svs.numbergames = svs.numbergames || {};
svs.numbergames.results = svs.numbergames.results || {};
svs.numbergames.results.parsers = svs.numbergames.results.parsers || {};
svs.numbergames.results.models = svs.numbergames.results.models || {};
svs.numbergames.results.collections = svs.numbergames.results.collections || {};
svs.numbergames.results.views = svs.numbergames.results.views || {};
svs.numbergames.results.behaviors = svs.numbergames.results.behaviors || {};
svs.numbergames.results.radio = svs.numbergames.results.radio || {};
svs.numbergames.results.logger = new svs.core.log.Logger('numbergames:results');
svs.numbergames.results.jackpotsRadio = Backbone.Radio.channel('numbergames:results:jackpots');

 })(window);